export default {
    我已阅读并同意: '我已閱讀並同意',
    用户协议: '用戶協議',
    隐私声明: '隱私聲明',
    '，并授权复星财富获得MyLink登录手机号': '，並授權復星財富獲得MyLink登錄手機號',
    '登录/注册': '登錄/註冊',
    请阅读并勾选用户协议: '請閱讀並勾選用戶協議',
    '服务器连接中，请稍后再试': '伺服器連接中，請稍後重試',
    '当前系统版本过低，请升级': '當前系統版本過低，請升級\n手機系統版本至最新版本',
    '暂不支持当前账户类型通过MyLink使用复星财富服务。': '暫不支持當前賬戶類型通過MyLink使用復星財富服務。',
    '如有疑问，请致电': '如有疑問，請致電',
    '联系复星财富客服。': '聯繫復星財富客服。',
}
